import React, { useCallback, useMemo, useState } from 'react';
import { descriptionAttributes, descriptionTags, InnerHtml } from 'src/ui/common/atoms/inner-html';
import { useTranslation } from 'next-i18next';
import { StyledShowMore } from './styles';

const LIMIT = 100;

export const ShowMoreText: React.VFC<{
    description?: string, className?: string, shortLabel?: boolean
}> = (
    { className, description, shortLabel }
) => {
    const { t } = useTranslation(['actions']);
    const [showAll, setShowAll] = useState(false);

    const locales = useMemo(() => ({
        showMore: t(shortLabel ? 'misc.more' : 'misc.showMore'),
        showLess: t(shortLabel ? 'misc.less' : 'misc.showLess'),
    }), [t, shortLabel]);

    const isAllVisible = useMemo(() => (
        !!description && (description.length <= LIMIT)
    ), [description]);

    const visibleText = useMemo(() => {
        if (!description) {
            return '';
        }
        if (showAll || description.length < LIMIT) {
            return description;
        }
        return description.slice(0, LIMIT);
    }, [description, showAll]);

    const showMore = useCallback(() => setShowAll(true), []);
    const hideMore = useCallback(() => setShowAll(false), []);

    const allTextVisible = visibleText === description;

    if (!description) {
        return null;
    }

    return (
        <div className={className}>
            <InnerHtml
                value={visibleText}
                allowedTags={descriptionTags}
                allowedAttributes={descriptionAttributes}
            />
            {!allTextVisible && '...'}
            {!isAllVisible && !showAll && (
                <StyledShowMore onClick={showMore}>{locales.showMore}</StyledShowMore>
            )}
            {showAll && (
                <StyledShowMore onClick={hideMore}>{locales.showLess}</StyledShowMore>
            )}
        </div>
    );
};
